module.exports = __webpack_public_path__ + "img/yuchan.583f2d68.png";